import { render, staticRenderFns } from "./OriginSubtitle.vue?vue&type=template&id=0888ae90&"
import script from "./OriginSubtitle.vue?vue&type=script&lang=js&"
export * from "./OriginSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports